// extracted by mini-css-extract-plugin
module.exports = {"container":"form_container__A99eV","inner":"form_inner__2lrXH","content":"form_content__1RRW4","last":"form_last__3EAIL","column":"form_column__1J-TH"};